export default __webpack_public_path__ + "static/media/global-icon-four.c9a58bf7.svg";